import createVueComponent from '../createVueComponent';

const Clock5 = createVueComponent('Clock5Icon', [
  ['circle', { cx: '12', cy: '12', r: '10' }],
  ['polyline', { points: '12 6 12 12 14.5 16' }],
]);

export default Clock5;
